import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import PageStart from './page/PageStart';
import LoginPage from './page/LoginPage';
import PageError from './page/PageError';
import Main from './page/MainPage';
import { AuthProvider, useAuth } from './service/AuthContext';
import DataUpdate from './page/DataUpdate';
import { useEffect, useState } from 'react';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path='/' element={<RoleBasedRedirect />} />
          <Route exact path='page' element={<PageStart />} />
          <Route path='login/:role' element={<LoginPage />} />
          <Route path='main/:role' element={<Main />} />
          <Route path='dataUpdate' element={<DataUpdate />} />
          <Route path='*' element={<PageError />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function RoleBasedRedirect() {
  const { currentUser, userInfo } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentUser) {
      setLoading(false);
    } else {
      setLoading(false); // If there's no currentUser, we're still done loading
    }
  }, [currentUser]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login/student" />;
  }

  if (userInfo) {
    switch (userInfo.role) {
      case 'admin':
        return <Navigate to="/main/admin" />;
      case 'teacher':
        return <Navigate to="/main/teacher" />;
      case 'student':
        return <Navigate to="/main/student" />;
      default:
        return <Navigate to="/login/student" />;
    }
  } else {
    return <Navigate to="/login/student" />;
  }
}

export default App;
